import { type RefObject, useCallback } from 'react'
import type { ActionHistoryEntry, VisitLifecycleAction } from './useTrackActionHistory'

type Input = {
  recordedActionsRef: RefObject<Set<VisitLifecycleAction>>
  setActionHistory: StateSetter<ActionHistoryEntry[]>
}

export function useRecordAction({ recordedActionsRef, setActionHistory }: Input) {
  // Helper function to record an action (only once per action type unless reset)
  return useCallback(
    (action: VisitLifecycleAction) => {
      // Skip if we've already recorded this action
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      if (recordedActionsRef.current.has(action)) {
        return
      }
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      recordedActionsRef.current.add(action)
      setActionHistory((actions) => [
        ...actions,
        {
          type: action,
          timestamp: Date.now(),
        },
      ])
    },
    [recordedActionsRef, setActionHistory],
  )
}
